module.exports = __webpack_public_path__ + "img/cuff_button_diameter.d20f636d.png";